export const setUser = activeUsername => {
    return {type: 'SET_USERNAME', payload: activeUsername}
}